import React, { useContext, useState, useEffect } from 'react';
import { FormContext } from '../../Pages/Apply'
import * as Yup from 'yup';
import axios from 'axios';
import { Formik, Form } from 'formik';
import { BASE_URL } from '../../config'
import useApi from '../../Hooks/useApi'
import SelectControl from '../SelectControl'
import swal from 'sweetalert'
import TextboxControl from '../TextboxControl';
import InputMaskControl from '../InputMaskControl';
import { parse, isDate } from "date-fns";
import { AuthContext } from '../../context/AuthContext'
import utilities from '../../utilities'


const ApplicantProfile = (props) => {

  const [progress, setProgress] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const [previousCategoryID, setPreviousCategoryID] = useState(0);
  const [previousData, setPreviousData] = useState(null);

  const [stepData, setStepData] = useState({ registrationID: 0, categoryID: 0, studentName: '', fatherName: '', photo: '/defaultavatar.jpg', cnic: '', mobileNo: '', dob: '', address: '', category: '' })
  const { userInfo } = useContext(AuthContext);

  const { data: categories } = useApi({ url: '/Registration/GetInstituteCategories', method: 'get' });

  const { activeStepIndex, setActiveStepIndex, formData, setFormData } = useContext(FormContext);


  const validFileExtensions = { image: ['jpg', 'png', 'jpeg'] };

  function isValidFileType(fileName, fileType) {
    return fileName && validFileExtensions[fileType].indexOf(fileName.split('.').pop()) > -1;
  }

  function getAllowedExt(type) {
    return validFileExtensions[type].map((e) => `.${e}`).toString()
  }

  let allowedExts = getAllowedExt('image');
  const MAX_FILE_SIZE = 102400;

  const handleFileUpload = (event, formik) => {
    let startAt = Date.now();
    const file = event.target.files[0];
    var size = file.size;

    var fileName = file.name;
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
      //TO DO
    } else {
      swal({
        title: "Attention!",
        text: 'Only jpg/jpeg and png files are allowed!',
        icon: "info",
      });
      return;
    }



    if (size > MAX_FILE_SIZE) {
      swal({
        title: "Attention!",
        text: 'only allowed 100 KB file size.',
        icon: "info",
      });

      //alert('only allowed 500 kb file size');
      return;
    }
    const fd = new FormData();
    fd.append("file", file);
    axios
      .post(BASE_URL + "/Registration/UploadDocument", fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${userInfo.jwt}`
        },
        onUploadProgress: function (progressEvent) {

          const { loaded, total } = progressEvent;
          const percentage = (loaded * 100) / total;
          setProgress(+percentage.toFixed(2));
          const timeElapsed = Date.now() - startAt;
          const uploadSpeed = loaded / timeElapsed;
          const duration = (total - loaded) / uploadSpeed;
          setRemaining(duration);
        }
      })
      .then((response) => {
        formik.setFieldValue('photo', response.data)
        formik.values.photo = response.data;
        const data = { ...stepData, ...formik.values };
        setStepData(data);


        //setStepData(step => ({
        //  ...step,
        //  ['photo'] : response.data,
        //}))
      })
      .catch((error) => {
        console.log(error);
      });
  };


  const validationScheme = Yup.object().shape({
    categoryID: Yup.string().required("Required").test('len', 'Required', (category) => {
      const catid = parseInt(category);
      return catid > 0;
    }),
    studentName: Yup.string().required("Required"),
    fatherName: Yup.string().required("Required"),
    photo: Yup.string().required("Required").test('len', 'Upload Student Pic', (pic) => {
      return pic.indexOf('defaultavatar.jpg') === -1;
    }),
    address: Yup.string().required("Required").min(15, 'Address is too short.'),
    cnic: Yup.string().required("Required").test("len", "Invalid", (val) => {
      const val_length_without_dashes = val.replace(/-|_/g, "").length;
      return val_length_without_dashes === 13;
    }),
    mobileNo: Yup.string().required("Required").test("len", "Invalid", (val) => {
      const val_length_without_dashes = val.replace(/-|_/g, "").length;
      return val_length_without_dashes === 11;
    }),
    dob: Yup.date().required("Required").typeError('Invalid').transform(parseDateString).max(new Date(new Date().setFullYear(new Date().getFullYear() - 13)), 'Wrong DOB'),
  })

  const checkIfDuplicateApplication = async (cnic) => {
    var isDuplicate = await utilities.getAsyncData({ url: '/Registration/CheckIfDuplicateApplication?CNIC=' + cnic, jwt: userInfo.jwt });
    return isDuplicate;
  }

  const checkIfDuplicateMobileNo = async (mobile) => {
    var isDuplicate = await utilities.getAsyncData({ url: '/Registration/CheckIfDuplicateStudentContactNo?ContactNo=' + mobile, jwt: userInfo.jwt });
    return isDuplicate;
  }

  const checkIfAllSeatsFilled = async (categoryid) => {
    var isFiled = await utilities.getAsyncData({ url: '/Registration/CheckIfAllSeatsFilled?CategoryID=' + categoryid, jwt: userInfo.jwt });
    return isFiled;
  }

  const selectedCategory = async (e, form) => {
    if (e.target.selectedIndex > 0) {
      setPreviousCategoryID(stepData.categoryID);
      var cat = e.target.options[e.target.selectedIndex].text;
      form.values.category = cat;
      const data = { ...stepData, ...form.values };
      setStepData(data);
    }

  }


  function parseDateString(value, originalValue) {
    const parsedDate = isDate(originalValue)
      ? originalValue
      : parse(originalValue, "dd/MM/yyyy", new Date());

    return parsedDate;
  }


  useEffect(() => {
    setStepData((prevState) => ({
      ...prevState,
      ...formData,
    }));


  }, [formData]);

  const submit = async (values, { setSubmitting }) => {
    if (stepData.registrationID > 0) {

      //irfan
      if (stepData.mobileNo != values.mobileNo) {
        var isDuplicateContact = await checkIfDuplicateMobileNo(values.mobileNo);
        if (isDuplicateContact) {
          swal({
            title: "Attention!",
            text: 'This contact number has already been entered.',
            icon: "error",
          });
          setSubmitting(false);
          return;
        }
      }

      if (stepData.cnic != values.cnic) {
        var isDuplicate = await checkIfDuplicateApplication(values.cnic);
        if (isDuplicate) {
          swal({
            title: "Attention!",
            text: 'Student contact number has already been entered.',
            icon: "error",
          });
          setSubmitting(false);
          return;
        }

      }

      var selectedCategoryID = parseInt(stepData.categoryID);
      if (previousCategoryID == 0 || selectedCategoryID == previousCategoryID) {
        const data = { ...formData, ...values };
        setFormData(data);
        setSubmitting(false);
        setActiveStepIndex(activeStepIndex + 1);
      }
      else {
        var isAllSeatsFilled = await checkIfAllSeatsFilled(values.categoryID);
        if (isAllSeatsFilled) {
          swal({
            title: "Attention!",
            text: 'You have registered all the sanctioned seats against this category.',
            icon: "info",
          });
          setSubmitting(false);
        }
        else {
          const data = { ...formData, ...values };
          setFormData(data);
          setSubmitting(false);
          setActiveStepIndex(activeStepIndex + 1);
        }
      }
    }
    else {

     //irfan
      var isDuplicateContact = await checkIfDuplicateMobileNo(values.mobileNo);
      if (isDuplicateContact) {
        swal({
          title: "Attention!",
          text: 'Student contact number has already been entered',
          icon: "info",
        });
        setSubmitting(false);
        return;
      }

      var isDuplicate = await checkIfDuplicateApplication(values.cnic);
      if (isDuplicate) {
        swal({
          title: "Attention!",
          text: 'Application of this student has already been submitted.',
          icon: "info",
        });
        setSubmitting(false);
      }
      else {
        var isAllSeatsFilled = await checkIfAllSeatsFilled(values.categoryID);
        if (isAllSeatsFilled) {
          swal({
            title: "Attention!",
            text: 'You have registered all the sanctioned seats against this category.',
            icon: "info",
          });
          setSubmitting(false);
        }
        else {
          const data = { ...formData, ...values };
          setFormData(data);
          setSubmitting(false);
          setActiveStepIndex(activeStepIndex + 1);
        }
      }

    }




  }



  return (
    <>
      <div className="">

        <Formik initialValues={stepData} validationSchema={validationScheme} onSubmit={submit} enableReinitialize >
          {formik => (

            <Form style={{ padding: '50px', paddingBottom: '10px' }} className='row g-3'>

              <div className='mb-3 col-12'>
                <p class="text-uppercase fs-5 fw-bold">Applicant Information</p>
                <hr></hr>
                <div className='text-center'>
                  <div>
                    <span>Student Photo </span>
                  </div>

                  <label htmlFor="fileInput" className="custom-file-upload fa">
                    <div className="img-wrap img-upload" >
                      <img id="avtaar" for="fileInput" src={stepData.photo} />

                    </div>

                    {!userInfo.isPortalLocked ? (<>
                      <input id="fileInput" name="fileInput" type="file" accept=".jpg,.jpeg,.png" onChange={(e) => { handleFileUpload(e, formik) }} />
                    </>) : (null)}


                  </label>
                  {formik.errors.photo ? (
                    <div style={{ color: 'red' }}>{formik.errors.photo}</div>
                  ) : null}

                </div>

              </div>

              <div className='col-12'>
                <SelectControl label="Category/ Course" className="form-control" name="categoryID" placeholder="Category/ Course" onBlurCapture={(e) => { selectedCategory(e, formik) }}>
                  <option selected value="">---</option>
                  {categories?.map((category, key) => {
                    return (
                      <option value={category.categoryID} key={category.categoryID} >{category.categoryName}</option>
                    )
                  })
                  }
                </SelectControl>
              </div>
              <div className='col-md-6'>
                <TextboxControl label="Student Name" className="form-control" name="studentName" type="text" placeholder="Student Name" />
              </div>
              <div className='col-md-6'>
                <TextboxControl label="Father Name" className="form-control" name="fatherName" type="text" placeholder="Father Name" />
              </div>
              <div className='col-md-4'>
                <InputMaskControl label="Student CNIC/ Form-B" className="form-control" name="cnic" mask='99999-9999999-9' placeholder="CNIC" />
              </div>
              <div className='col-md-4'>
                <InputMaskControl label="Student DOB (day/month/year)" className="form-control" name="dob" mask='99/99/9999' placeholder="Date of Birth(day/month/year)" />
              </div>
              <div className='col-md-4'>
                <InputMaskControl label="Student Mobile No." className="form-control" name="mobileNo" mask='9999-9999999' placeholder="Mobile No." />
              </div>
              <div className='col-12'>
                <TextboxControl label="Student Postal Address" className="form-control" name="address" type="text" placeholder="Address" />
              </div>

              <div className="d-grid gap-2 pb-3 pt-4">
                <button className="btn btn-primary" type="submit" disabled={!(formik.isValid) || formik.isSubmitting}>
                  {formik.isSubmitting ?
                    (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) :
                    (<span >Next</span>)
                  }
                </button>

              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );

};

export default ApplicantProfile;
